import React, { useEffect, useState } from "react";
import { Row, Col, Card, Table, Button } from "antd";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import "./Checkout.css";
import Axios from "axios";
import constants from "../constants/constants.json";
import Message from "../helper/Message";
import moment from "moment";

export default function Checkout(props) {
  const invoice = useSelector((state) => state.userReducer.invoice);
  const history = useHistory();
  const [loadingCheckout, setLoadingCheckout] = useState(false);

  const CheckoutReq = async () => {
    try {
      Message.info("Waiting for Bank Response");
      setLoadingCheckout(true);
      const token = localStorage.getItem("pnsToken");
      let response = await Axios.get(
        constants.url + "/plan/checkout/" + invoice.invoice.uid,
        {
          headers: {
            authorization: "Bearer " + token,
          },
        }
      );
      if (response.data.status === 202) {
        window.location.href = response.data.result.checkout.url;
      } else {
        Message.error(response.data.result.message);
      }
      setLoadingCheckout(false);
    } catch (err) {
      Message.error("Communication error");
      setLoadingCheckout(false);
    }
  };
  const columns = [
    {
      title: "Plan Name",
      dataIndex: "name",
      key: "name",
    },

    {
      title: "Plan Features",
      dataIndex: "features",
      key: "features",
      render: (features) => {
        return (
          <ul>
            {features &&
              features.split("\n").map((element) => {
                return <li>{element}</li>;
              })}
          </ul>
        );
      },
    },

    {
      title: "Time Limit",
      dataIndex: "limit",
      key: "limit",
      render : (limit) => {
        return (limit && <span>{limit / 3600} Hrs</span>)
      }
    },
    {
      title: "Plan Price",
      dataIndex: "value",
      key: "value",
    },
  ];
  useEffect(() => {
    if (Object.keys(invoice).length === 0) {
      history.replace("/dashboard/plans");
    }
  });
  return (
    Object.keys(invoice).length !== 0 && (
      <Row justify="center">
        <Col xs={24} sm={24} md={20} lg={18} xl={15}>
          <Card>
            <Row justify="center">
              <span className="chaeckout-card-title">Invoice</span>
            </Row>
            <Row justify="center" className="checkout-invoice">
              <span className="checkout-invoice-detail">
                Invoice Date:{" "}
                {moment
                  .unix(invoice.invoice.createTime)
                  .format("YYYY/MM/DD HH:mm")}
              </span>
              <span className="checkout-invoice-detail">
                Invoice Id: {invoice.invoice.uid}
              </span>
            </Row>
            <div className="checkout-card-details">
              <div className="checkout-seller">
                <span className="checkout-seller-name">Seller Name: Pns</span>
                <span className="checkout-seller-name">
                  Seller Tel: +989123456789
                </span>
              </div>
              <div className="checkout-buyer">
                <span className="checkout-buyer-name">
                  Buyer Name: {invoice.user.name}
                </span>
                <span className="checkout-buyer-mail">
                  Buyer Mail: {invoice.user.mail}
                </span>
              </div>
            </div>
            <div className="checkout-table-container">
              <Table
                dataSource={[invoice.plan, { value: invoice.plan.value }]}
                bordered
                columns={columns}
                pagination={false}
              />
            </div>
            <Button
              type="primary"
              onClick={CheckoutReq}
              loading={loadingCheckout ? <Loading3QuartersOutlined spin /> : false}
              style={{
                marginTop: "20px",
              }}
            >
              Checkout
            </Button>
          </Card>
        </Col>
      </Row>
    )
  );
}
